import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import * as stylex from "@stylexjs/stylex";
import { queries } from "../lib/api";
import { styles } from "../lib/styles";
import { NavIcon, PageHeader } from "../components/Workspace";
import { historySearchSchema } from "../lib/schemas";
import { RequestFailure } from "../components/RequestFailure";
import { RecordingPlayer } from "../components/RecordingPlayer";

export const Route = createFileRoute("/recordings/$recordingId")({
  validateSearch: historySearchSchema,
  component: RecordingDetail,
});
function RecordingDetail() {
  const { recordingId } = Route.useParams();
  const filters = Route.useSearch();
  const me = useQuery(queries.me());
  const preview = useQuery({
    ...queries.recording(recordingId),
    enabled: me.data?.roles.includes("auditor") === true,
  });
  if (me.isPending) return <p aria-busy="true">Checking recording permissions…</p>;
  if (!me.data?.roles.includes("auditor"))
    return (
      <p role="alert" {...stylex.props(styles.error)}>
        Auditor access is required to review this recording.
      </p>
    );
  return (
    <>
      <Link to="/recordings" search={filters} className="breadcrumb">
        <NavIcon name="ArrowLeft" /> Session recordings
      </Link>
      <PageHeader
        title={preview.data?.recording.alias ?? "Recording"}
        description={
          preview.data
            ? `${preview.data.recording.email} · ${new Date(preview.data.recording.created_at).toLocaleString()}`
            : "Recorded SSH output and session activity."
        }
      />
      {preview.isPending && (
        <p aria-busy="true" {...stylex.props(styles.notice)}>
          Loading recording…
        </p>
      )}
      <RequestFailure
        error={preview.error}
        retry={() => {
          void preview.refetch();
        }}
        pending={preview.isFetching}
      />
      {preview.data && (
        <RecordingPlayer preview={preview.data} canExport={me.data.roles.includes("exporter")} />
      )}
    </>
  );
}
